import React from "reactn";
import axios from "axios";
import { startOfWeek, differenceInCalendarWeeks, addWeeks } from "date-fns";
import ScheduleSelector from "react-schedule-selector";

class TourAvailability extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      schedule: []
    };
    this.handleRangeSelection = this.handleRangeSelection.bind(this);
  }

  async componentDidMount() {
    try {
      this.setGlobal({ loading: true });
      const res = await axios.get(
        `${process.env.REACT_APP_API}/edu/tour/availability/${this.props.program.profile.dsUserId}`
      );
      if (res.data.success) {
        const mappedTimes = res.data.data.availability.map(time => {
          const wkDiff = Math.abs(
            differenceInCalendarWeeks(new Date(), new Date(time))
          );
          return new Date(addWeeks(new Date(time), wkDiff));
        });
        this.setState({ schedule: mappedTimes });
      }
      this.setGlobal({ loading: false, lastAPICall: res });
    } catch (ex) {
      this.setGlobal({ loading: false, lastAPICall: null });
    }
  }

  async handleRangeSelection(item) {
    try {
      this.setGlobal({ loading: true });
      const res = await axios.post(
        `${process.env.REACT_APP_API}/edu/tour/availability/${this.props.program.profile.dsUserId}`,
        { availability: this.state.schedule }
      );
      if (res.data.success) {
        this.setState({ schedule: res.data.data.availability });
      }
      this.setGlobal({ loading: false, lastAPICall: res });
    } catch (ex) {
      this.setGlobal({ loading: false, lastAPICall: null });
    }
  }

  render() {
    return (
      <div className="container-fluid">
        <div className="cont">
          <div className="row">
            <div className="col-md-12">
              <h1>Tour Request Availability</h1>
            </div>
          </div>
        </div>
        <div className="cont">
          <ScheduleSelector
            selection={this.state.schedule}
            numDays={7}
            minTime={7}
            maxTime={22}
            startDate={startOfWeek(new Date())}
            onChange={e => this.setState({ schedule: e })}
            dateFormat="ddd"
          />
        </div>
        <div className="cont">
          <div className="buttons">
            <button
              className="savebtn"
              onClick={() => this.handleRangeSelection()}
            >
              SAVE
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default TourAvailability;
